export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-8001HD_white-b4df39dd4964659598e17fd62da346f6.webp";